'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cc = require('classcat');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cc__default = /*#__PURE__*/_interopDefaultLegacy(cc);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css$3 = ".react-input_1-3-3_co-input {\n  --input-background-color: var(--white);\n  --input-color: var(--var-gray-800);\n  --input-border-color: var(--gray-400);\n  --input-hover-border-color: var(--gray-500);\n  --input-focus-border-color: var(--primary-500);\n  box-sizing: border-box;\n  width: 100%;\n  height: var(--input-height);\n  padding: 0 8px;\n  border: 2px solid var(--input-border-color);\n  border-radius: 4px;\n  outline: none;\n  color: var(--input-color);\n  background-color: var(--input-background-color);\n  font-weight: 400;\n  font-family: var(--font-family);\n  transition: border 0.2s ease;\n  touch-action: manipulation;\n}\n.react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled])[data-co-hover], .react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled]):hover {\n  border-color: var(--input-hover-border-color);\n}\n.react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled])[data-co-focus], .react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled])[data-co-focus][data-co-hover], .react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled])[data-co-focus]:hover, .react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled]):focus, .react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled]):focus[data-co-hover], .react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled]):focus:hover, .react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled])[data-co-focus-within], .react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled])[data-co-focus-within][data-co-hover], .react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled])[data-co-focus-within]:hover, .react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled]):focus-within, .react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled]):focus-within[data-co-hover], .react-input_1-3-3_co-input:not([disabled]):not([data-co-disabled]):focus-within:hover {\n  border-color: var(--input-focus-border-color);\n}\n\n.react-input_1-3-3_co-input.react-input_1-3-3_co-input--small {\n  --input-height: 32px;\n  font-size: 13px;\n}\n.react-input_1-3-3_co-input.react-input_1-3-3_co-input--medium, .react-input_1-3-3_co-input {\n  --input-height: 40px;\n  font-size: 14px;\n}\n.react-input_1-3-3_co-input.react-input_1-3-3_co-input--error {\n  --input-border-color: var(--error-700);\n  --input-hover-border-color: var(--error-500);\n  --input-focus-border-color: var(--error-500);\n}\n.react-input_1-3-3_co-input.react-input_1-3-3_co-input--warning {\n  --input-border-color: var(--warning-700);\n  --input-hover-border-color: var(--warning-500);\n  --input-focus-border-color: var(--warning-500);\n}\n.react-input_1-3-3_co-input.react-input_1-3-3_co-input--unstyled {\n  height: 100%;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background-color: transparent;\n}\n.react-input_1-3-3_co-input.react-input_1-3-3_co-input--wrap {\n  height: unset;\n  min-height: var(--input-height);\n}\n.react-input_1-3-3_co-input.react-input_1-3-3_co-input--clickable {\n  cursor: pointer;\n}\n.react-input_1-3-3_co-input.react-input_1-3-3_co-input--align-left, .react-input_1-3-3_co-input {\n  text-align: left;\n}\n.react-input_1-3-3_co-input.react-input_1-3-3_co-input--align-center {\n  text-align: center;\n}\n.react-input_1-3-3_co-input.react-input_1-3-3_co-input--align-right {\n  text-align: right;\n}\n.react-input_1-3-3_co-input[disabled], .react-input_1-3-3_co-input[readonly], .react-input_1-3-3_co-input[data-co-disabled], .react-input_1-3-3_co-input[data-co-readonly] {\n  --input-background-color: var(--gray-200);\n  --input-color: var(--gray-500);\n  --input-border-color: var(--gray-300);\n}\n.react-input_1-3-3_co-input[disabled], .react-input_1-3-3_co-input[data-co-disabled] {\n  pointer-events: none;\n}\n.react-input_1-3-3_co-input[type=number] {\n  appearance: textfield;\n}\n.react-input_1-3-3_co-input[type=number].react-input_1-3-3_co-input--no-arrows[type=number]::-webkit-inner-spin-button, .react-input_1-3-3_co-input[type=number].react-input_1-3-3_co-input--no-arrows[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.react-input_1-3-3_co-input::placeholder {\n  color: var(--gray-500);\n  font-weight: 300;\n}";
var styles$2 = {
  "co-input": "react-input_1-3-3_co-input",
  "co-input--small": "react-input_1-3-3_co-input--small",
  "co-input--medium": "react-input_1-3-3_co-input--medium",
  "co-input--error": "react-input_1-3-3_co-input--error",
  "co-input--warning": "react-input_1-3-3_co-input--warning",
  "co-input--unstyled": "react-input_1-3-3_co-input--unstyled",
  "co-input--wrap": "react-input_1-3-3_co-input--wrap",
  "co-input--clickable": "react-input_1-3-3_co-input--clickable",
  "co-input--align-left": "react-input_1-3-3_co-input--align-left",
  "co-input--align-center": "react-input_1-3-3_co-input--align-center",
  "co-input--align-right": "react-input_1-3-3_co-input--align-right",
  "co-input--no-arrows": "react-input_1-3-3_co-input--no-arrows"
};
styleInject(css$3);

var css$2 = ".react-input_1-3-3_co-checkbox {\n  --checkbox-size: 20px;\n  position: relative;\n  margin: 0;\n  padding: 0;\n  flex-shrink: 0;\n  background-color: transparent;\n  outline: 0;\n  border: 0;\n  cursor: pointer;\n  appearance: none;\n}\n.react-input_1-3-3_co-checkbox, .react-input_1-3-3_co-checkbox:before, .react-input_1-3-3_co-checkbox:after {\n  box-sizing: border-box;\n  width: var(--checkbox-size);\n  height: var(--checkbox-size);\n}\n.react-input_1-3-3_co-checkbox:before, .react-input_1-3-3_co-checkbox:after {\n  content: \"\";\n  position: absolute;\n  transition-property: background-color, border-color, opacity;\n  transition-duration: 0.3s;\n  transition-timing-function: ease;\n}\n.react-input_1-3-3_co-checkbox:before {\n  background-color: var(--white);\n  border: 2px solid var(--gray-500);\n  border-radius: 4px;\n}\n.react-input_1-3-3_co-checkbox:checked:before {\n  background-color: var(--primary-600);\n  border-color: var(--primary-600);\n}\n.react-input_1-3-3_co-checkbox:checked:after {\n  background: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiICB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgIDxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0yMSw3TDksMTlMMy41LDEzLjVMNC45MSwxMi4wOUw5LDE2LjE3TDE5LjU5LDUuNTlMMjEsN1oiIC8+Cjwvc3ZnPgo=\") transparent center;\n  background-size: var(--checkbox-size) var(--checkbox-size);\n}\n.react-input_1-3-3_co-checkbox[data-co-focus]:before, .react-input_1-3-3_co-checkbox:focus:before {\n  box-shadow: 0 0 0 2px var(--primary-500);\n}\n.react-input_1-3-3_co-checkbox[data-co-disabled], .react-input_1-3-3_co-checkbox[disabled] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.react-input_1-3-3_co-checkbox[data-co-disabled]:not(:checked):before, .react-input_1-3-3_co-checkbox[disabled]:not(:checked):before {\n  background-color: var(--gray-200);\n}\n.react-input_1-3-3_co-checkbox:indeterminate:before {\n  background-color: var(--gray-200);\n  border: 2px solid var(--gray-400);\n}\n.react-input_1-3-3_co-checkbox:indeterminate:after {\n  background: url(\"data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE5IDEzSDV2LTJoMTR2MnoiIGZpbGw9IiNBRUIzQjgiIC8+PC9zdmc+Cg==\") transparent center;\n  background-size: var(--checkbox-size) var(--checkbox-size);\n}";
var checkboxStyles = {
  "co-checkbox": "react-input_1-3-3_co-checkbox"
};
styleInject(css$2);

const Checkbox = ({
  className = "",
  forwardedRef,
  checked,
  ...props
}) => {
  const classStyles = cc__default['default']({
    [checkboxStyles["co-checkbox"]]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React__default['default'].createElement("input", _extends({
    type: "checkbox",
    className: classStyles,
    ref: forwardedRef,
    checked: !!checked
  }, props, {
    "data-co-name": "Checkbox",
    "data-co-version": "1.3.3",
    "data-co-project": "cobalt"
  }));
};

var css$1 = ".react-input_1-3-3_co-radio {\n  --radio-size: 20px;\n  position: relative;\n  margin: 0;\n  padding: 0;\n  flex-shrink: 0;\n  outline: 0;\n  border: 0;\n  cursor: pointer;\n  appearance: none;\n}\n.react-input_1-3-3_co-radio, .react-input_1-3-3_co-radio:before, .react-input_1-3-3_co-radio:after {\n  box-sizing: border-box;\n}\n.react-input_1-3-3_co-radio, .react-input_1-3-3_co-radio:before {\n  width: var(--radio-size);\n  height: var(--radio-size);\n}\n.react-input_1-3-3_co-radio:before, .react-input_1-3-3_co-radio:after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n  background-color: var(--white);\n  transition-duration: 0.3s;\n  transition-timing-function: ease;\n}\n.react-input_1-3-3_co-radio:before {\n  border: 2px solid var(--gray-500);\n  transition-property: background-color, border-color;\n}\n.react-input_1-3-3_co-radio:after {\n  width: 8px;\n  height: 8px;\n  top: 6px;\n  margin-left: 6px;\n  opacity: 0;\n  transition-property: opacity;\n}\n.react-input_1-3-3_co-radio:checked::before {\n  background-color: var(--primary-600);\n  border-color: var(--primary-600);\n}\n.react-input_1-3-3_co-radio:checked::after {\n  opacity: 1;\n}\n.react-input_1-3-3_co-radio[data-co-focus]::before, .react-input_1-3-3_co-radio:focus::before {\n  box-shadow: 0 0 0 2px var(--primary-500);\n}\n.react-input_1-3-3_co-radio[data-co-disabled], .react-input_1-3-3_co-radio[disabled] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.react-input_1-3-3_co-radio[data-co-disabled]:not([checked]):before, .react-input_1-3-3_co-radio[disabled]:not([checked]):before {\n  background-color: var(--gray-200);\n}";
var styles$1 = {
  "co-radio": "react-input_1-3-3_co-radio"
};
styleInject(css$1);

const Radio = ({
  className = "",
  forwardedRef,
  checked,
  ...props
}) => {
  const classStyles = cc__default['default']({
    [styles$1["co-radio"]]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React__default['default'].createElement("input", _extends({
    type: "radio",
    className: classStyles,
    ref: forwardedRef,
    checked: !!checked
  }, props, {
    "data-co-name": "Radio",
    "data-co-version": "1.3.3",
    "data-co-project": "cobalt"
  }));
};

var css = ".react-input_1-3-3_co-color-input {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n}\n.react-input_1-3-3_co-color-input::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n.react-input_1-3-3_co-color-input::-webkit-color-swatch {\n  border-radius: 0;\n  border: none;\n}\n.react-input_1-3-3_co-color-input::-moz-color-swatch {\n  border: none;\n}";
var styles = {
  "co-color-input": "react-input_1-3-3_co-color-input"
};
styleInject(css);

const Color = ({
  className = "",
  forwardedRef,
  ...props
}) => {
  const classStyles = cc__default['default']([styles["co-color-input"], className]);
  return /*#__PURE__*/React__default['default'].createElement("input", _extends({
    type: "color",
    className: classStyles,
    ref: forwardedRef
  }, props, {
    "data-co-name": "ColorInput",
    "data-co-version": "1.3.3",
    "data-co-project": "cobalt"
  }));
};

const classModifiers = {
  small: "co-input--small",
  medium: "co-input--medium",
  left: "co-input--align-left",
  center: "co-input--align-center",
  right: "co-input--align-right",
  error: "co-input--error",
  warning: "co-input--warning",
  unstyled: "co-input--unstyled"
};

const getModifierClass = modifier => modifier && styles$2[classModifiers[modifier]];

const getComponentTag = type => {
  switch (type) {
    case "checkbox":
      return Checkbox;

    case "radio":
      return Radio;

    case "color":
      return Color;

    default:
      return null;
  }
};

const Input = ({
  className = "",
  forwardedRef,
  noArrows,
  textAlign = "left",
  type = "text",
  size = "medium",
  variation,
  ...props
}) => {
  const classStyles = cc__default['default']([styles$2["co-input"], getModifierClass(variation), styles$2[classModifiers[size]], styles$2[classModifiers[textAlign]], {
    [styles$2["co-input--no-arrows"]]: noArrows
  }, className]);
  const Tag = getComponentTag(type);

  if (Tag) {
    return /*#__PURE__*/React__default['default'].createElement(Tag, _extends({
      className: className,
      forwardedRef: forwardedRef,
      "data-co-disabled": props.disabled || undefined,
      "aria-disabled": props.disabled || undefined
    }, props, {
      "data-co-name": "Input",
      "data-co-version": "1.3.3",
      "data-co-project": "cobalt"
    }));
  }

  return /*#__PURE__*/React__default['default'].createElement("input", _extends({
    type: type,
    className: classStyles,
    ref: forwardedRef,
    "data-co-disabled": props.disabled || undefined,
    "aria-disabled": props.disabled || undefined
  }, props, {
    "data-co-name": "Input",
    "data-co-version": "1.3.3",
    "data-co-project": "cobalt"
  }));
};

exports.default = Input;
